import _ from 'lodash';
import constants from "@/components/configurator/Editor/lib/_constants.js";
import Point from "@/components/configurator/Editor/lib/Cordinates/Point";

const state = () => ({
    basicBlock: "double",
    color: "black",
    shape: "rectangle",
    shapeInputs: {
        a: 0,
        b: 0,
        c: 0,
        d: 0,
    },
    shapeInputRules: {
        rectangle: ["a", "b"],
        tform: ["a", "b", "c", "d"],
        square: ["a"],
        uform: ["a", "b", "c", "d"],
        empty: [],
    },
})

const getters = {
    getColor(state) {
        return state.color
    },
    getShape(state) {
        return state.shape
    },
    getBasicBlock(state) {
        return state.basicBlock
    },
    /**
     * 
     * @param {*} state 
     * @param {string} input 
     * 
     * If input is null it return object of all inputs
     * If input is a string it will return the value of the key represented by input
     */
    getShapeInputs(state) {
        return state.shapeInputs
    },
    getShapeInputRules(state) {
        return state.shapeInputRules
    },
    shapeInputsTouched(state) {
        return !_.isEqual(state.shapeInputs, {
            a: 0,
            b: 0,
            c: 0,
            d: 0,
        })
    }
};

//const actions = {};

const mutations = {
    setColor(state, newColor) {
        state.color = newColor
    },
    setShape(state, newShape) {
        state.shape = newShape
    },
    
    setBasicBlock(state, newBlock) {
        state.basicBlock = newBlock
    },
    /**
     * 
     * @param {*} state 
     * @param {int|object} newInput 
     * @param {string} input 
     * 
     * If input is specified then only set value for theat key 
     * If input is not specefied then ovveride whole object
     */
    setShapeInputs(state, newInput, input = null) {
        if (!input) {
            state.shapeInputs = newInput
        } else {
            state.shapeInputs[input] = newInput
        }
    },
    generateElements(state) {
        let xMin = null;
        let yMin = null;
        let xMax = null;
        let yMax = null;
        const elements = [];

        function createItem(x,y,color, type, ymax = 0) {
            let p = new Point(x + 250, y + (250 - ymax), 0);
            return {
                type: constants.BASE_ELEMENT,
                cords: p,
                level: 0,
                name: type,
                settings: { color: color },
            };
        }

        let yStep = state.basicBlock == 'single' ? 1 : 2;

        switch (state.shape) {
        case 'rectangle': {
            xMax = state.shapeInputs["a"] * 2;
            yMax = state.shapeInputs["b"] * 2;
            for (let y = 0; y < yMax; y += yStep) {
                for (let x = 0; x < xMax; x++) {
                    let item = createItem(x,y,state.color, state.basicBlock, yMax);
                    elements.push(item);
                }
            }
            break;
        }
        case 'tform': {
            console.log(state.shapeInputs["b"], state.shapeInputs["d"], state.shapeInputs["b"]);
            xMax = (state.shapeInputs["b"] + state.shapeInputs["d"] + state.shapeInputs["b"]) * 2;
            yMax = state.shapeInputs["a"] * 2;
            let height = (state.shapeInputs["a"] + state.shapeInputs["c"]);
            console.log(xMax, yMax, yStep);
            for (let y = 0; y < yMax; y += yStep) {
                for (let x = 0; x < xMax; ++x) {
                    let item = createItem(x,y - height,state.color, state.basicBlock, height);
                    elements.push(item);
                }
            }

            xMin = state.shapeInputs["b"] * 2;
            yMin = yMax;
            xMax = state.shapeInputs["d"] * 2 + xMin;
            yMax = state.shapeInputs["c"] * 2 + yMin;
            for (let y = yMin; y < yMax; y += yStep) {
                for (let x = xMin; x < xMax; ++x) {
                    let item = createItem(x,y - height,state.color, state.basicBlock, height);
                    elements.push(item);
                }
            }
            break;
        }
        case 'square': {
            xMax = state.shapeInputs["a"] * 2;
            yMax = state.shapeInputs["a"] * 2;
            console.log(xMax, yMax);
            for (let y = 0; y < yMax; y += yStep) {
                for (let x = 0; x < xMax; ++x) {
                    let item = createItem(x,y,state.color, state.basicBlock, yMax);
                    elements.push(item);
                }
            }
            break;
        }
        case 'uform': {
            console.log(state.shapeInputs);
            xMin = 0;
            xMax = state.shapeInputs["a"] * 2;
            yMin = 0;
            yMax = state.shapeInputs["b"] * 2;
            let height = state.shapeInputs["a"] * 2 + state.shapeInputs["c"] * 2;
            for (let y = yMin; y < yMax; y += yStep) {
                for (let x = xMin; x < xMax; ++x) {
                    let item = createItem(x,y-height,state.color, state.basicBlock);
                    elements.push(item);
                }
            }

            xMin = (state.shapeInputs["a"] + state.shapeInputs["c"]) * 2;
            xMax += xMin;
            for (let y = yMin; y < yMax; y += yStep) {
                for (let x = xMin; x < xMax; ++x) {
                    let item = createItem(x,y-height,state.color, state.basicBlock);
                    elements.push(item);
                }
            }

            xMin = 0;
            xMax = (state.shapeInputs["a"] + state.shapeInputs["c"] + state.shapeInputs["a"]) * 2;
            yMin = state.shapeInputs["b"] * 2;
            yMax = state.shapeInputs["d"] * 2 + yMin;
            for (let y = yMin; y < yMax; y += yStep) {
                for (let x = xMin; x < xMax; ++x) {
                    let item = createItem(x,y-height,state.color, state.basicBlock);
                    elements.push(item);
                }
            }
            break;
        }
        default:
            // report error
            break;
        }
        this.commit('projectData/setConfiguration', elements)
    }
};

//const methods = {};


export default {
    namespaced: true,
    state,
    getters,
    //actions,
    mutations,
};